import React from 'react';
import moment from 'moment';
import * as query from '../helpers/query';
import * as photosService from '../services/photos';
import * as photoSetsService from '../services/photoSets';
import FilterSidebar from '../FilterSidebar';
import Header from '../Header';
import MapView from '../MapView';
import PhotoSetSlider from '../PhotoSetSlider';
import PhotoSetView from '../PhotoSetView';
import EmbedModal from '../modals/EmbedModal';
import InformationModal from '../modals/InformationModal';
import UserModal from '../modals/UserModal';
import * as Turf from '@turf/turf';

const ACTIVE_PHOTO = Symbol();
const ACTIVE_PHOTO_SET = Symbol();

class Home extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            bounds: null,
            filters: {

                fromUtc: moment.utc().add(-1, 'weeks').hours(0).minutes(0).seconds(0).milliseconds(0),
                highlightedOnly: false,
                multiplePhotosOnly: false,
                tags: [],
                toUtc: moment.utc().add(1, 'days').hours(0).minutes(0).seconds(0).milliseconds(0),
                timePreset: 'week',
            },
            photos: [],
            photoSets: [],
            visiblePhotoSets: [],
            photoSetsUnfiltered: [],
            showEmbedModal: false,
            showFilterSidebar: true,
            showInformationModal: false,
            showUserModal: false,
            userLocation: undefined,
        };

        this.handleUserLocationChange = this.handleUserLocationChange.bind(this);
        this.handleActivePhotoChange = this.handleActivePhotoChange.bind(this);
        this.handleActivePhotoSetChange = this.handleActivePhotoSetChange.bind(this);
        this.handleMapContentChange = this.handleMapContentChange.bind(this);
        this.handleBoundsChange = this.handleBoundsChange.bind(this);
        this.handleEmbedClick = this.handleEmbedClick.bind(this);
        this.handleEmbedModalClose = this.handleEmbedModalClose.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleFilterClick = this.handleFilterClick.bind(this);
        this.handleInformationClick = this.handleInformationClick.bind(this);
        this.handleInformationModalClose = this.handleInformationModalClose.bind(this);
        this.handlePhotoSetViewClose = this.handlePhotoSetViewClose.bind(this);
        this.handlePhotoSetViewOpen = this.handlePhotoSetViewOpen.bind(this);
        this.handleUserClick = this.handleUserClick.bind(this);
        this.handleUserModalClose = this.handleUserModalClose.bind(this);
        this.isPhotoLocationNearUserLocation = this.isPhotoLocationNearUserLocation.bind(this);
        this.handleTimePresetChange = this.handleTimePresetChange.bind(this);
    }

    applyClientFilters() {

        this.setState((prevState, props) => {

            // Currently, client side filters have been removed in favor of server side filtering.
            // The mechanism is left intact for future use cases.

            // const photoSets = prevState.photoSetsUnfiltered.filter(photoSet => {
            //
            //     if (prevState.filters.highlightedOnly && !photoSet.highlighted) return false;
            //     if (prevState.filters.multiplePhotosOnly && photoSet.photos.length < 2) return false;
            //     if (!prevState.filters.tags.every(tag => photoSet.tags.includes(tag))) return false;
            //
            //     return true;
            // });

            const photoSets = [...prevState.photoSetsUnfiltered];

            return {

                photoSets,
                photos: photoSets.length === 0 ? [] : photoSets.map(photoSet => photoSet.photos).reduce((a, b) => [...a, ...b]),
            };
        });
    }

    async componentDidMount() {

        const params = new URLSearchParams(this.props.location.search);

        const aroundPhotoId = params.has('activePhoto') ? Number(params.get('activePhoto')) : null;
        const aroundPhotoSetId = params.has('activePhotoSet') ? Number(params.get('activePhotoSet')) : null;

        const filters = await Home.getFiltersAround({photoId: aroundPhotoId, photoSetId: aroundPhotoSetId});

        if (filters) {

            this.setState((prevState, props) => ({

                // Changing filters will automatically trigger a data fetch.

                filters: Object.assign({}, prevState.filters, filters),
            }));
        }
        else
            this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {

        if (
            !prevState.filters.fromUtc.isSame(this.state.filters.fromUtc, 'day')
            || prevState.filters.highlightedOnly !== this.state.filters.highlightedOnly
            || prevState.filters.multiplePhotosOnly !== this.state.filters.multiplePhotosOnly
            || prevState.filters.tags.length !== this.state.filters.tags.length // Tags cannot be altered so we can simply check the length as long as we do it immediately.
            || !prevState.filters.toUtc.isSame(this.state.filters.toUtc, 'day')
        ) {

            this.fetchData();
        }
    }

    handleTimePresetChange(filter) {
        
        let fromUtc = moment.utc().add(1, 'days').hours(0).minutes(0).seconds(0).milliseconds(0);
        let toUtc = fromUtc;

        switch(filter.timePreset) {
            case "day":
                fromUtc = moment.utc().add(-1, 'days').hours(0).minutes(0).seconds(0).milliseconds(0);;
                break;
            case "week":
                fromUtc = moment.utc().add(-1, 'weeks').hours(0).minutes(0).seconds(0).milliseconds(0);;
                break;
            case "month":
                fromUtc = moment.utc().add(-1, 'months').hours(0).minutes(0).seconds(0).milliseconds(0);;
                break;
            default:
              console.warn("Unknown period selected");
        }

        filter.fromUtc = fromUtc;
        filter.toUtc = toUtc;

        this.setState((prevState, props) => ({

            filters: Object.assign({}, prevState.filters, filter),
        }));
    }

    fetchData() {

        const {fromUtc, highlightedOnly, multiplePhotosOnly, tags, toUtc} = this.state.filters;

        photoSetsService.getByParameters({

                // boundingbox: this.state.bounds ? this.state.bounds.toBBoxString() : undefined,
                fromUtc: fromUtc.toJSON(),
                highlighted: highlightedOnly ? true : undefined,
                minPhotos: multiplePhotosOnly ? 2 : undefined,
                tags: tags.length > 0 ? tags.join(',') : undefined,
                toUtc: toUtc.toJSON(),
            })
            .then(result => result.items)
            .then(photoSets => {

                this.setState({photoSetsUnfiltered: photoSets}, () => this.applyClientFilters());
            });
    }

    getActivePhoto(state = this.state) {

        const params = new URLSearchParams(this.props.location.search);
        const activePhotoId = params.has('activePhoto') ? Number(params.get('activePhoto')) : null;

        if (!activePhotoId) {

            this[ACTIVE_PHOTO] = null;
        }
        else if ((this[ACTIVE_PHOTO] || {}).id !== activePhotoId) {

            const activePhotoSet = this.getActivePhotoSet(state);
            const photos = activePhotoSet ? activePhotoSet.photos : [];

            this[ACTIVE_PHOTO] = photos.find(photo => photo.id === activePhotoId);
        }

        return this[ACTIVE_PHOTO];
    }

    getActivePhotoSet(state = this.state) {

        const params = new URLSearchParams(this.props.location.search);
        const activePhotoSetId = params.has('activePhotoSet') ? Number(params.get('activePhotoSet')) : null;

        if (!activePhotoSetId) {

            this[ACTIVE_PHOTO_SET] = null;
        }
        else if ((this[ACTIVE_PHOTO_SET] || {}).id !== activePhotoSetId) {

            this[ACTIVE_PHOTO_SET] = state.photoSets.find(photoSet => photoSet.id === activePhotoSetId);
        }

        return this[ACTIVE_PHOTO_SET];
    }

    getFullScreen() {

        return ['true', '1'].includes(new URLSearchParams(this.props.location.search).get('fullScreen'));
    }

    isPhotoLocationNearUserLocation(coords) {
        if (!this.state.userLocation) return false;

        const photoLocation = Turf.point(coords),
            userLocation = Turf.point([this.state.userLocation.latitude, this.state.userLocation.longitude]),
            userAccuracy = this.state.userLocation.accuracy / 100;

        const radius = Turf.buffer(userLocation, userAccuracy + 100, {units: 'meters'});

        const photosAllowed = Turf.booleanContains(radius, photoLocation);

        return photosAllowed;
    }

    handleUserLocationChange(userLocation) {
        this.setState({userLocation});
    }

    handleActivePhotoChange(photo) {

        this.setQueryParameters({

            activePhoto: photo.id,
            activePhotoSet: photo.photoSetId,
        });
    }

    handleActivePhotoSetChange(photoSet) {

        const activePhoto = this.getActivePhoto();

        this.setQueryParameters({

            activePhoto: (activePhoto || {}).photoSet === photoSet ? activePhoto.id : photoSet.photos[0].id,
            activePhotoSet: photoSet.id,
        });
    }

    handleMapContentChange(visiblePhotoSets) {

        this.setState({visiblePhotoSets});

    }

    handleBoundsChange(bounds) {

        this.setState({bounds});

    }

    handleEmbedClick() {

        this.setState({showEmbedModal: true});
    }

    handleEmbedModalClose() {

        this.setState({showEmbedModal: false});
    }

    handleFilterChange(filter) {

        if (filter.timePreset && filter.timePreset !== "customDate") {
            this.handleTimePresetChange(filter);
            return;
        };

        this.setState((prevState, props) => ({

            filters: Object.assign({}, prevState.filters, filter),
        }));
    }

    handleFilterClick() {

        this.setState((prevState, props) => ({

            showFilterSidebar: !prevState.showFilterSidebar,
        }));
    }

    handleInformationClick() {

        this.setState({showInformationModal: true});
    }

    handleInformationModalClose() {

        this.setState({showInformationModal: false});
    }

    handlePhotoSetViewClose() {

        this.setQueryParameters({fullScreen: false});
    }

    handlePhotoSetViewOpen() {

        this.setQueryParameters({fullScreen: true});
    }

    handleUserClick() {

        this.setState({showUserModal: true});
    }

    handleUserModalClose() {

        this.setState({showUserModal: false});
    }

    render() {
        return (

            <div className="d-flex flex-column" style={{height: '100vh'}}>

                <Header filterActive={this.state.showFilterSidebar}
                        onEmbedClick={this.handleEmbedClick}
                        onFilterClick={this.handleFilterClick}
                        onInformationClick={this.handleInformationClick}
                        onUserClick={this.handleUserClick}/>

                <div className="container-fluid d-flex flex-column position-relative" style={{flex: 1}}>
                    <FilterSidebar filters={this.state.filters} show={this.state.showFilterSidebar} onFilterChange={this.handleFilterChange}/>
                    <div className="row" style={{flex: 1}}>

                        <MapView photoSets={this.state.photoSets}
                                 activePhotoSet={this.getActivePhotoSet()}
                                 onActivePhotoSetChange={this.handleActivePhotoSetChange}
                                 onBoundsChange={this.handleBoundsChange}
                                 onMapContentChange={this.handleMapContentChange}
                                 onPhotoSetViewOpen={this.handlePhotoSetViewOpen}
                                 onUserLocationChange={this.handleUserLocationChange}
                                 style={{flex: "auto"}}
                                 isPhotoLocationNearUserLocation={this.isPhotoLocationNearUserLocation} />

                    </div>
                    <div className="row">

                        <div className="col">
                            <PhotoSetSlider photoSets={this.state.photoSets}
                                            activePhotoSet={this.getActivePhotoSet()}
                                            onActivePhotoSetChange={this.handleActivePhotoSetChange}
                                            visiblePhotoSets={this.state.visiblePhotoSets} 
                                            bounds={this.state.bounds} />
                        </div>

                    </div>
                </div>

                {(this.getFullScreen() && this.getActivePhotoSet()) && <PhotoSetView photoSet={this.getActivePhotoSet()}
                                                                                     activePhoto={this.getActivePhoto()}
                                                                                     onActivePhotoChange={this.handleActivePhotoChange}
                                                                                     onClose={this.handlePhotoSetViewClose}
                                                                                     isPhotoLocationNearUserLocation={this.isPhotoLocationNearUserLocation} />}

                <EmbedModal show={this.state.showEmbedModal} tags={this.state.filters.tags} bounds={this.state.bounds} onClose={this.handleEmbedModalClose}/>
                <InformationModal show={this.state.showInformationModal} onClose={this.handleInformationModalClose}/>
                <UserModal show={this.state.showUserModal} onClose={this.handleUserModalClose}/>

            </div>
        );
    }

    setQueryParameters(params) {

        const current = new URLSearchParams(this.props.location.search);

        const queryActivePhoto = current.has('activePhoto') ? Number(current.get('activePhoto')) : undefined;
        const queryActivePhotoSet = current.has('activePhotoSet') ? Number(current.get('activePhotoSet')) : undefined;
        const queryFullScreen = ['true', '1'].includes(current.get('fullScreen'));

        // We shouldn't update the URL unnecessarily, as it might trigger unexpected route props to update, triggering an infinite component update loop.

        if (queryActivePhoto !== params.activePhoto || queryActivePhotoSet !== params.activePhotoSet || queryFullScreen !== params.fullScreen) {

            this.props.history.push({

                search: query.buildQueryString(Object.assign({

                    activePhoto: queryActivePhoto,
                    activePhotoSet: queryActivePhotoSet,
                    fullScreen: queryFullScreen,

                }, params)),
            });
        }
    }

    static async getFiltersAround({photoId, photoSetId} = {}) {

        let time;

        try {

            if (photoSetId) {

                const photoSet = (await photoSetsService.getById(photoSetId)).item;
                time = moment(photoSet.photos[photoSet.photos.length - 1].time).utc();
            }
            else if (photoId) {

                const photo = (await photosService.getById(photoId)).item;
                time = moment(photo.time).utc();
            }
        }
        catch (ex) {

            console.log(ex);
            return;
        }

        return time ? {

            fromUtc: time.clone().add(-2, 'weeks').hours(0).minutes(0).seconds(0).milliseconds(0),
            toUtc: time.clone().add(2, 'weeks').hours(0).minutes(0).seconds(0).milliseconds(0),

        } : null;
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/Home.js